import { render, staticRenderFns } from "./OrderStatusForm.vue?vue&type=template&id=bec1d5b8"
import script from "./OrderStatusForm.vue?vue&type=script&lang=js"
export * from "./OrderStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports